import {validateField, clearFields} from './helpers/form'
import {
  CLEAR_VACANCY_CANDIDATE_SEARCH_FIELDS,
  VALIDATE_VACANCY_CANDIDATE_SEARCH_FIELD
} from '../../../actions/pages/vacancy-page'

export function vacancyCandidateSearch (
  state = {
    valid: false,
    fields: [
      {
        name: 'SearchText',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Search text'
        }
      }
    ]
  },
  action
) {
  switch (action.type) {
    case VALIDATE_VACANCY_CANDIDATE_SEARCH_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_VACANCY_CANDIDATE_SEARCH_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
